import { styled, Button, CircularProgress } from '@mui/material';
import { theme } from 'assets/themes/zizzi';

const spinnerColor = theme.palette.white;

export const StyledButton = styled(Button)``;

export const ButtonInner = styled('div')`
  padding: 0 30px;
  position: relative;
`;

export const Spinner = styled(CircularProgress)`
  left: -10px;
  position: absolute;
  top: -5px;

  svg {
    transform: scale(50%);
    color: ${spinnerColor};
  }
`;
